import React from 'react';
import {
  Card,
  MenuItem,
  SelectField,
  RaisedButton,
  IconButton,
} from 'material-ui';
import {
  Restricted,
  ViewTitle,
  GET_LIST,
  translate as t,
} from 'admin-on-rest';
import { random, set } from 'lodash';
import AddIcon from 'material-ui/svg-icons/content/add-circle';
import RemoveIcon from 'material-ui/svg-icons/content/remove-circle';

import firestore from '../config/firestore-init';
import { kunal } from '../client';
import kunalClient from '../client/kunalClient';
import './styles.css';


const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:4042/api';
const restClient = kunalClient(API_BASE_URL, kunal);

const positionRoleMap = {
  franchisees: 'manager',
  areaManager: 'superAdmin',
  restaurantManager: 'manager',
  socialMediaManager: 'operator',
  economy: 'operator',
  steward: 'manager',
  waiter: 'operator',
  barManager: 'editor',
  bartender: 'operator',
  chef: 'editor',
  sousChef: 'editor',
  cook: 'operator',
  dishwasher: 'operator',
  prospect: 'guest',
};

class Simulator extends React.Component { // eslint-disable-line
  constructor(props) {
    super(props);
    this.state = {
      fields: [],
      languages: ['sv', 'en', 'da', 'nb', 'fi', 'de', 'es'],
      selectedLanguages: [],
      defaultRole: '',
    };
  }
  componentWillMount = async () => {
    const user = await firestore.collection('users').where('phoneNumber', '==', this.props.user.phoneNumber).get().then((querySnapshot) => {
      const usr = [];
      querySnapshot.forEach((doc) => {
        console.log('doc', doc.data());
        usr.push(doc.data());
      });
      return usr[0];
    });
    this.setState({
      user,
      simulation: user.simulation,
      defaultVenue: user.simulation ? user.simulatedDefaultVenue : user.defaultVenue,
      defaultPosition: user.simulation ? user.simulatedDefaultPosition : '',
      defaultRole: user.simulation ? user.simulatedDefaultRole : '',
      permissions: user.simulation ? user.simulatedPermissions : user.permissions,
      selectedLanguages: user.simulation ? user.simulatedLanguages : [],
    });

    const roles = await firestore.collection('roles').get().then((querySnapshot) => {
      const rls = [];
      querySnapshot.forEach((doc) => rls.push(doc.data().name));
      return rls;
    });
    this.setState({ roles });

    const positions = await firestore.collection('positions').get().then((querySnapshot) => {
      const rls = [];
      querySnapshot.forEach((doc) => rls.push(doc.data().name));
      return rls;
    });
    this.setState({ positions });

    await restClient(GET_LIST, 'venues', {
      sort: {},
      pagination: {},
      filter: {},
    })
      .then((venues) => this.setState({ venues: venues.data }))
      .catch((e) => { console.log('Venues fetch Error', e); this.props.showNotification('Could not get venues', 'warning'); });
  }


  startSimulation = async () => {
    const { user } = this.props;
    const { defaultVenue, defaultPosition, fields, defaultRole, selectedLanguages } = this.state;

    const permissions = {
      [defaultVenue]: {
        position: [defaultPosition],
        role: defaultRole || positionRoleMap[defaultPosition],
      },
    };

    if (fields.length > 0) {
      fields.forEach((field) => set(permissions, field.venue, { position: [field.position], role: positionRoleMap[field.position] }));
    }
    const result = await firestore.collection('users').where('phoneNumber', '==', user.phoneNumber).get().then((querySnapshot) => {
      const userId = [];
      querySnapshot.forEach((doc) => {
        userId.push(doc.id);
      });
      return firestore.collection('users').doc(userId[0]).update({
        simulation: true,
        simulatedDefaultRole: defaultRole || positionRoleMap[defaultPosition],
        simulatedPermissions: permissions,
        simulatedDefaultVenue: defaultVenue,
        simulatedDefaultPosition: defaultPosition,
        simulatedLanguages: selectedLanguages,
      })
        .then(() => 'success')
        .catch((err) => err);
    }).then((res) => {
      if (res !== 'success') {
        return Promise.reject(res);
      }
      return res;
    })
      .catch((err) => {
        console.log('Firebase update failed', err);
        return err;
      });
    if (result instanceof Error) {
      this.setState({ error: 'Firebase Update Error', msg: result.message });
      return;
    }
    if (result === 'success') {
      this.setState({ simulation: true, permissions, defaultVenue });
    }
  }

  cancelSimulation = async () => {
    const { user } = this.props;

    const cancelResult = await firestore.collection('users').where('phoneNumber', '==', user.phoneNumber).get().then((querySnapshot) => {
      const userId = [];
      querySnapshot.forEach((doc) => {
        userId.push(doc.id);
      });
      return firestore.collection('users').doc(userId[0]).update({
        simulation: false,
        simulatedDefaultRole: '',
        simulatedPermissions: {},
      }).then(() => 'success')
        .catch((err) => err);
    }).then((res) => {
      if (res !== 'success') {
        return Promise.reject(res);
      }
      return res;
    })
      .catch((err) => {
        console.log('Firebase update failed', err);
        return err;
      });
    if (cancelResult instanceof Error) {
      console.log(cancelResult);
      this.setState({ error: 'Firebase Update Error', msg: cancelResult.message });
      return;
    }
    if (cancelResult === 'success') {
      this.setState({ simulation: false, permissions: {}, defaultVenue: '', defaultPosition: '', fields: [], defaultRole: '', selectedLanguages: [] });
    }
  }

  addFields = () => {
    const { fields } = this.state;
    fields.push({ id: this.state.fields.length + random(0, 10000), venue: '', position: '' });
    this.setState({ fields });
  }

  handleFieldChange = (event, key, value, id, type) => {
    const { fields } = this.state;
    const updatedField = { id, [type]: value };
    const updatedFields = fields.map((field) => field.id === id ? { ...field, ...updatedField } : field);

    this.setState({ fields: updatedFields });
  }

  removeField = (id) => this.setState((prevState) => ({ fields: prevState.fields.filter((field) => field.id !== id) }))

  handleDefaultVenueChange = (event, key, value) => this.setState({ defaultVenue: value });
  handleDefaultPositionChange = (event, key, value) => this.setState({ defaultPosition: value });
  handleDefaultRoleChange = (event, key, value) => this.setState({ defaultRole: value });

  handleLanguageChange = (event, key, value) => this.setState({ selectedLanguages: value });

  handleClick = (role) => {
    this.startSimulation(this.props.user, role);
  }

  render() {
    const { user, translate } = this.props;
    const { venues, positions, defaultVenue, defaultPosition, fields, permissions, defaultRole, roles, languages, selectedLanguages } = this.state;
    console.log('this.props', this.props, this.state);
    return (
      <Card className="simulator-container--card">
        <ViewTitle title="SIMULATOR" />
        {
          user && (user.superUser || user.simulation) ? (
            <div>
              <div className="simulator-controllers">
                <RaisedButton label="Start Simulation" onClick={this.startSimulation} primary />
                <RaisedButton label="Stop Simulation" onClick={this.cancelSimulation} />
              </div>

              <div className="simulator-default-values">
                <SelectField
                  floatingLabelText="Default Venue"
                  onChange={this.handleDefaultVenueChange}
                  value={defaultVenue}
                >
                  {venues && venues.map((v) => (
                    <MenuItem value={v.name} key={v.name} primaryText={v.name} />
                  ))}
                </SelectField>

                <SelectField
                  floatingLabelText="Default Position"
                  onChange={this.handleDefaultPositionChange}
                  value={defaultPosition}
                >
                  {positions && positions.map((p) => (
                    <MenuItem value={p} key={p} primaryText={p} />
                  ))}
                </SelectField>

                <SelectField
                  floatingLabelText="Default Role"
                  onChange={this.handleDefaultRoleChange}
                  value={defaultRole}
                >
                  {roles && roles.map((r) => (
                    <MenuItem value={r} key={r} primaryText={r} />
                  ))}
                </SelectField>
                {
                  defaultRole === 'translator' && (
                    <SelectField
                      floatingLabelText="Languages"
                      onChange={this.handleLanguageChange}
                      value={selectedLanguages}
                      multiple
                    >
                      {languages && languages.map((r) => (
                        <MenuItem
                          value={r}
                          primaryText={translate(`languages.${r}`)}
                          checked={selectedLanguages.includes(r)}
                        />
                      ))}
                    </SelectField>
                  )
                }
              </div>

              {
                fields && fields.map((field) => (
                  <div className="simulator-field--div">
                    <VenueSelector
                      venues={venues}
                      field={field}
                      handleChange={this.handleFieldChange}
                    />
                    <PositionSelector
                      positions={positions}
                      field={field}
                      handleChange={this.handleFieldChange}
                    />
                    <IconButton className="simulator-remove-field--button" children={<RemoveIcon />} onClick={() => this.removeField(field.id)} />
                  </div>
                ))
              }

              <div className="simulator-add-fields">
                <IconButton className="simulator-add-fields--button" children={<AddIcon />} onClick={this.addFields} />
              </div>

              {
                this.state.error && (
                  <div>
                    {`Simulation failed: ${this.state.error} ${this.state.msg}`}
                  </div>
                )
              }
              {
                (user && this.state.simulation) && (
                  <CurrentSimulation
                    defaultVenue={user.simulatedDefaultVenue}
                    defaultPosition={user.simulatedDefaultPosition}
                    permissions={permissions}
                    defaultRole={defaultRole}
                    languages={selectedLanguages}
                    translate={translate}
                  />
                )
              }
            </div>
          ) : null
        }

      </Card>
    );
  }
}

const VenueSelector = ({ venues, field, handleChange }) => (
  <SelectField
    floatingLabelText="Venues"
    onChange={(event, key, value) => handleChange(event, key, value, field.id, 'venue')}
    value={field.venue}
  >
    {venues && venues.map((v) => (
      <MenuItem value={v.name} key={v.name} primaryText={v.name} />
    ))}
  </SelectField>
);

const PositionSelector = ({ positions, field, handleChange }) => (
  <SelectField
    floatingLabelText="Positions"
    onChange={(event, key, value) => handleChange(event, key, value, field.id, 'position')}
    value={field.position}
  >
    {positions && positions.map((p) => (
      <MenuItem value={p} key={p} primaryText={p} />
    ))}
  </SelectField>
);

const CurrentSimulation = ({ defaultVenue, defaultPosition, permissions, defaultRole, languages, translate }) => (
  <React.Fragment>
    <div className="simulator-status">
      <h2 className="simulator-simulation-active-title">You are now simulating</h2>
      <p><strong>Default Venue: </strong> {defaultVenue}</p>
      <p><strong>Default Position: </strong> {defaultPosition}</p>
      <p><strong>Default Role: </strong> {defaultRole}</p>
      {
        defaultRole === 'translator' && (
          <p><strong>Languages: </strong> {languages.map((lang) => translate(`languages.${lang}`)).join(', ')}</p>
        )
      }
      { Object.keys(permissions).length > 1 && Object.keys(permissions).map((venue, i) => (
        <React.Fragment>
          <p>{`Venue ${i + 1}`} </p>
          <div><strong>Venue: </strong>{venue}</div>
          <div><strong>Position: </strong>{permissions[venue].position.map((pos) => pos)}</div>
          <div><strong>Role: </strong>{permissions[venue].role}</div>
        </React.Fragment>
      ))}
    </div>
  </React.Fragment>
);

const Simsim = t((props) => (
  <Restricted authParams={{ route: '/simulator' }} location={props.location}>
    { props.user ? <Simulator {...props} /> : <div></div>}
  </Restricted>
));

export default Simsim;
